import type { DefaultDashboardDefinition } from './dashboard-definition';

export const financeRecordDashboard: DefaultDashboardDefinition = {
  id: "finance.record",
  appId: "finance",
  name: "Finance Record dashboard",
  record: {
    separator: ".",
    suffix: "summary",
    placementIds: "static",
    placementSeparator: ".",
  },
  queryScope: null,
  placements: [
    {
      id: "finance.record.debits.default",
      widgetId: "finance.record.debits",
      placement: {
        x: 0,
        y: 0,
        width: 3,
        height: 1,
      },
    },
    {
      id: "finance.record.credits.default",
      widgetId: "finance.record.credits",
      placement: {
        x: 3,
        y: 0,
        width: 3,
        height: 1,
      },
    },
    {
      id: "finance.record.movement.default",
      widgetId: "finance.record.movement",
      placement: {
        x: 6,
        y: 0,
        width: 3,
        height: 1,
      },
    },
    {
      id: "finance.record.items.default",
      widgetId: "finance.record.items",
      placement: {
        x: 9,
        y: 0,
        width: 3,
        height: 1,
      },
    },
    {
      id: "finance.record.debit-trend.default",
      widgetId: "finance.record.debit-trend",
      placement: {
        x: 0,
        y: 1,
        width: 6,
        height: 3,
      },
    },
    {
      id: "finance.record.credit-trend.default",
      widgetId: "finance.record.credit-trend",
      placement: {
        x: 6,
        y: 1,
        width: 6,
        height: 3,
      },
    },
  ],
};
